import { getFeatureFlagIsNew } from './feature-flag-defaults';

// Rebuilt demos and newly-covered catalog games stay image-only until an
// admin has explicitly reviewed and enabled them. This is intentionally keyed
// by the stable feature/game id, not by a temporary New badge.
export const DEMO_REVIEW_REQUIRED_GAME_IDS = new Set([
  'linkLogic', 'battleship', 'mafiaLite', 'fieldAgent', 'silentCode', 'cardsHub',
  'signalJam', 'blindSpot', 'songGuesser', 'voteParty', 'charades',
  'finishTheSentence', 'oneWordStory', 'twoTruthsAndALie', 'wordUnscramble',
  'categoryBlitz', 'sequenceMemory', 'numberMemory', 'patternLock', 'reflexDuel',
  'neuralPath', 'rockPaperScissors', 'lieDetector', 'boxCircuit',
  'raythreadRally', 'checkers', 'chess', 'puzzleTogether', 'blindMaze',
  'guessMyNumber', 'snakesAndLadders', 'empireGame', 'sheIsA10', 'escapeRoom',
  'racing', 'corebound', 'nightMarket', 'nanoSiege', 'salvageCrew', 'wobbleParty',
  'dareDistrict', 'teamSketch', 'blobBrawl', 'blasterBash', 'foamFrenzy', 'tumbleToss', 'eightBall', 'bobberBay', 'harvestHustle', 'relayRush', 'hillRush', 'tiltRally', 'tileRummy', 'doodlePost', 'pong', 'foosball', 'marbleRush',
]);

export function getGameDemoNeedsReview(
  gameId: string,
  explicitVisibility: boolean | undefined,
) {
  return DEMO_REVIEW_REQUIRED_GAME_IDS.has(gameId) && explicitVisibility !== true;
}

export function getGameDemoIsVisible(
  gameId: string,
  explicitVisibility: boolean | undefined,
  explicitIsNew?: boolean,
) {
  if (explicitVisibility !== undefined) return explicitVisibility;
  if (DEMO_REVIEW_REQUIRED_GAME_IDS.has(gameId)) return false;
  return !getFeatureFlagIsNew(gameId) && explicitIsNew !== true;
}
